import classnames from 'classnames';
import { getComponentMargin, getAnchorId } from '@/utils/builderUtils';

export default function Breadcrumbs(props: any) {
  return (
    <div
      {...getAnchorId(props?.anchorLinkID)}
      className={classnames('wrapper tw-w-full tw-min-h-[48px] tw-font-base', getComponentMargin(props?.margin))}
    >
      <ol className="breadcrumb" id="breadcrumb">
        <li className="breadcrumb_item">
          <a className="tw-font-nav-link" href="/">
            <span>Home</span>
          </a>
        </li>
        {props?.crumbs?.map((crumb: any, index: number) => (
          <li className="breadcrumb_item tw-font-nav-link" key={index}>
            <a href={crumb.uri} aria-label={crumb.pageName}>
              <span>{crumb.pageName}</span>
            </a>
          </li>
        ))}
        <li className="breadcrumb_item tw-font-nav-link">
          <span>{props.currentPageName}</span>
        </li>
      </ol>
    </div>
  );
}
